import React, { useState } from 'react';
import './Enroll.css';
import BeginnerIcn from "../assets/images/beginner-icn.png";
import CareerIcn from "../assets/images/career-icn.png";
import SupportIcn from "../assets/images/support-icn.png";
import PracticalIcn from "../assets/images/practical-icn.png";
import OverviewIcon from "../assets/images/overview-item-icon.png";
import AccessIcon from "../assets/images/enroll-btn-aro.png";

const Enroll = () => {
  const [expandedSection, setExpandedSection] = useState('mechanical');

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const curriculumSections = {
    mechanical: {
      title: 'Mechanical & Industrial Design',
      items: [
        'Robot Mathematics',
        'Robot Matrices',
        'Mechanical CAD',
        'Analysis and Prototyping'
      ]
    },
    electronics: {
      title: 'Electronics & IOT',
      items: [
        'Circuit Design Fundamentals',
        'Microcontroller Programming',
        'Sensor Integration',
        'IoT Protocol & Communication'
      ]
    },
    ml: {
      title: 'ML/AI & ROS-2',
      items: [
        'Machine Learning Basics',
        'Computer Vision',
        'ROS-2 Framework',
        'Autonomous Navigation'
      ]
    }
  };

  return (
    <div id='moduleenroll' className="enroll-container">
      <div className="enroll-wrapper">
        {/* Header */}
        <div className="enroll-header">
          <h1 className="enroll-title">
            Curriculum <span className="text-orange">Overview</span>
          </h1>
        </div>

        {/* Main Content Grid */}
        <div className="enroll-grid">
          {/* Left Column - Accordion */}
          <div className="accordion-section">
            <div className='secret-text'>
              Unlock the secret sauce behind <br></br><span>world-class products.</span>
            </div>
            {Object.entries(curriculumSections).map(([key, section]) => (
              <div key={key} className="accordion-item">
                <button
                  onClick={() => toggleSection(key)}
                  className="accordion-button"
                >
                  <span className="accordion-title">{section.title}</span>
                  <span className="accordion-icon">
                    {expandedSection === key ? '−' : '+'}
                  </span>
                </button>
                
                {expandedSection === key && (
                  <div className="accordion-content">
                    <ul className="accordion-list">
                      {section.items.map((item, index) => (
                        <li key={index} className="accordion-list-item">
                          <span className="bullet-point">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Right Column - Course Info Card */}
          <div className="course-card">
            <div className='course-top-content'>
            <div className="course-badge">
              <span className="bullet-point">•</span> 45 Days Training Program
            </div>
            <h2 className="course-title">
              Join <span className="text-orange">RoboAI</span> Today
            </h2>
            <div className="features-grid">
              <div className="feature-item">
                <span className="feature-icon"><img src={BeginnerIcn} className="icon-join" /></span>
                <span className="feature-text">Beginner Friendly</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon"><img src={CareerIcn} className="icon-join" /></span>
                <span className="feature-text">Career Guidance</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon"><img src={SupportIcn} className="icon-join" /></span>
                <span className="feature-text">Doubt Support</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon"><img src={PracticalIcn} className="icon-join" /></span>
                <span className="feature-text">Practical Projects</span>
              </div>
            </div>
            </div>

            {/* Quick Overview */}
            <div className="course-overview">
              <h3 className="overview-title">
                A Quick overview of Program
              </h3>
              <ul className="overview-list">
                <li className="overview-item">
                  <span className="check-icon"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>Instant access to the full 45 days curriculum</span>
                </li>
                <li className="overview-item">
                  <span className="check-icon"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>All future updates and bonus content included</span>
                </li>
                <li className="overview-item">
                  <span className="check-icon"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>Weekly live workshops</span>
                </li>
                <li className="overview-item">
                  <span className="check-icon"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>1 on 1 Mentorship</span>
                </li>
              </ul>
            </div>

            {/* CTA Button */}
           <div className='enroll-button-div'>
           <a href='https://pages.razorpay.com/ROBOAI-I90' target='_blank'>
            <button className="enroll-button">
              <span>Enroll Now to Access</span>
              <span className="button-arrow"><img src={AccessIcon} className="access-icon" /></span>
            </button>
            </a> 
            </div>  
          </div>
        </div>
      </div>
      
    </div>
    
  );
};

export default Enroll;